import { SELECTABLE_TIME_ZONES, LOCAL_TIME_ZONE } from '@customerio/fly-components/utils/time-zones';

export default SELECTABLE_TIME_ZONES;
export { LOCAL_TIME_ZONE };

export const CUSTOMER_TIME_ZONE = {
  name: "the user's time zone",
  label: "the user's time zone",
  value: 'customer_time_zone',
  offset: 0,
};

export const CAMPAIGN_TIME_ZONES = [CUSTOMER_TIME_ZONE].concat(SELECTABLE_TIME_ZONES);
